// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentRequestFieldsFragment = { __typename?: 'PaymentRequest', id: string, intent_id?: string | null, invoice_id?: string | null, status: Types.PaymentRequestStatus, type?: Types.PaymentRequestType | null, timing?: Types.PaymentRequestTiming | null, paid_offline?: boolean | null, created_at: number, updated_at: number, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string }>, booking: { __typename?: 'Booking', id: string } };

export type PaymentRequestSummaryFieldsFragment = { __typename?: 'AdditionalPaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', details_label?: string | null, display_value: string, label: string, details_value?: string | null, total: number }>, prices: Array<{ __typename?: 'QuotePrice', category?: Types.QuotePriceCategory | null, currency?: string | null, name: string, value: number, note?: string | null, subsections: Array<{ __typename?: 'PriceSubsection', category?: Types.QuotePriceCategory | null, currency?: string | null, name: string, value: number }> }> };

export type PaymentRequestQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PaymentRequestQuery = { __typename?: 'Query', paymentRequest: { __typename?: 'PaymentRequest', id: string, intent_id?: string | null, invoice_id?: string | null, status: Types.PaymentRequestStatus, type?: Types.PaymentRequestType | null, timing?: Types.PaymentRequestTiming | null, paid_offline?: boolean | null, created_at: number, updated_at: number, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string }>, booking: { __typename?: 'Booking', id: string } } };

export type AdditionalPaymentSummaryQueryVariables = Types.Exact<{
  bookingId: Types.Scalars['ID']['input'];
  data: Types.AdditionalPaymentSummaryInput;
}>;


export type AdditionalPaymentSummaryQuery = { __typename?: 'Query', additionalPaymentSummary: { __typename?: 'AdditionalPaymentSummary', total: number, line_items: Array<{ __typename?: 'LineItem', details_label?: string | null, display_value: string, label: string, details_value?: string | null, total: number }>, prices: Array<{ __typename?: 'QuotePrice', category?: Types.QuotePriceCategory | null, currency?: string | null, name: string, value: number, note?: string | null, subsections: Array<{ __typename?: 'PriceSubsection', category?: Types.QuotePriceCategory | null, currency?: string | null, name: string, value: number }> }> } };

export type CreatePaymentRequestMutationVariables = Types.Exact<{
  bookingId: Types.Scalars['ID']['input'];
  data: Types.CreatePaymentRequestInput;
  paymentData?: Types.InputMaybe<Types.ExternalPaymentInfoInput>;
}>;


export type CreatePaymentRequestMutation = { __typename?: 'Mutation', createPaymentRequest: { __typename?: 'PaymentRequest', id: string, intent_id?: string | null, invoice_id?: string | null, status: Types.PaymentRequestStatus, type?: Types.PaymentRequestType | null, timing?: Types.PaymentRequestTiming | null, paid_offline?: boolean | null, created_at: number, updated_at: number, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string }>, booking: { __typename?: 'Booking', id: string } } };

export type ConfirmOfflinePaymentRequestMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ConfirmOfflinePaymentRequestMutation = { __typename?: 'Mutation', confirmOfflinePaymentRequest: { __typename?: 'PaymentRequest', id: string, intent_id?: string | null, invoice_id?: string | null, status: Types.PaymentRequestStatus, type?: Types.PaymentRequestType | null, timing?: Types.PaymentRequestTiming | null, paid_offline?: boolean | null, created_at: number, updated_at: number, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string }>, booking: { __typename?: 'Booking', id: string } } };

export type CancelPaymentRequestMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type CancelPaymentRequestMutation = { __typename?: 'Mutation', cancelPaymentRequest: { __typename?: 'PaymentRequest', id: string, intent_id?: string | null, invoice_id?: string | null, status: Types.PaymentRequestStatus, type?: Types.PaymentRequestType | null, timing?: Types.PaymentRequestTiming | null, paid_offline?: boolean | null, created_at: number, updated_at: number, items: Array<{ __typename?: 'PaymentItemRequest', amount: number, description: string }>, booking: { __typename?: 'Booking', id: string } } };

export const PaymentRequestFieldsFragmentDoc = gql`
    fragment PaymentRequestFields on PaymentRequest {
  id
  items {
    amount
    description
  }
  booking {
    id
  }
  intent_id
  invoice_id
  status
  type
  timing
  paid_offline
  created_at
  updated_at
}
    `;
export const PaymentRequestSummaryFieldsFragmentDoc = gql`
    fragment PaymentRequestSummaryFields on AdditionalPaymentSummary {
  line_items {
    details_label
    display_value
    label
    details_value
    total
  }
  prices {
    category
    currency
    name
    value
    note
    subsections {
      category
      currency
      name
      value
    }
  }
  total
}
    `;
export const PaymentRequestDocument = gql`
    query paymentRequest($id: ID!) {
  paymentRequest(id: $id) {
    ...PaymentRequestFields
  }
}
    ${PaymentRequestFieldsFragmentDoc}`;

/**
 * __usePaymentRequestQuery__
 *
 * To run a query within a React component, call `usePaymentRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentRequestQuery(baseOptions: Apollo.QueryHookOptions<PaymentRequestQuery, PaymentRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentRequestQuery, PaymentRequestQueryVariables>(PaymentRequestDocument, options);
      }
export function usePaymentRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentRequestQuery, PaymentRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentRequestQuery, PaymentRequestQueryVariables>(PaymentRequestDocument, options);
        }
export type PaymentRequestQueryHookResult = ReturnType<typeof usePaymentRequestQuery>;
export type PaymentRequestLazyQueryHookResult = ReturnType<typeof usePaymentRequestLazyQuery>;
export type PaymentRequestQueryResult = Apollo.QueryResult<PaymentRequestQuery, PaymentRequestQueryVariables>;
export const AdditionalPaymentSummaryDocument = gql`
    query additionalPaymentSummary($bookingId: ID!, $data: AdditionalPaymentSummaryInput!) {
  additionalPaymentSummary(bookingId: $bookingId, data: $data) {
    ...PaymentRequestSummaryFields
  }
}
    ${PaymentRequestSummaryFieldsFragmentDoc}`;

/**
 * __useAdditionalPaymentSummaryQuery__
 *
 * To run a query within a React component, call `useAdditionalPaymentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalPaymentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalPaymentSummaryQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdditionalPaymentSummaryQuery(baseOptions: Apollo.QueryHookOptions<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>(AdditionalPaymentSummaryDocument, options);
      }
export function useAdditionalPaymentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>(AdditionalPaymentSummaryDocument, options);
        }
export type AdditionalPaymentSummaryQueryHookResult = ReturnType<typeof useAdditionalPaymentSummaryQuery>;
export type AdditionalPaymentSummaryLazyQueryHookResult = ReturnType<typeof useAdditionalPaymentSummaryLazyQuery>;
export type AdditionalPaymentSummaryQueryResult = Apollo.QueryResult<AdditionalPaymentSummaryQuery, AdditionalPaymentSummaryQueryVariables>;
export const CreatePaymentRequestDocument = gql`
    mutation createPaymentRequest($bookingId: ID!, $data: CreatePaymentRequestInput!, $paymentData: ExternalPaymentInfoInput) {
  createPaymentRequest(
    booking: $bookingId
    data: $data
    paymentData: $paymentData
  ) {
    ...PaymentRequestFields
  }
}
    ${PaymentRequestFieldsFragmentDoc}`;
export type CreatePaymentRequestMutationFn = Apollo.MutationFunction<CreatePaymentRequestMutation, CreatePaymentRequestMutationVariables>;

/**
 * __useCreatePaymentRequestMutation__
 *
 * To run a mutation, you first call `useCreatePaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentRequestMutation, { data, loading, error }] = useCreatePaymentRequestMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      data: // value for 'data'
 *      paymentData: // value for 'paymentData'
 *   },
 * });
 */
export function useCreatePaymentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentRequestMutation, CreatePaymentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentRequestMutation, CreatePaymentRequestMutationVariables>(CreatePaymentRequestDocument, options);
      }
export type CreatePaymentRequestMutationHookResult = ReturnType<typeof useCreatePaymentRequestMutation>;
export type CreatePaymentRequestMutationResult = Apollo.MutationResult<CreatePaymentRequestMutation>;
export type CreatePaymentRequestMutationOptions = Apollo.BaseMutationOptions<CreatePaymentRequestMutation, CreatePaymentRequestMutationVariables>;
export const ConfirmOfflinePaymentRequestDocument = gql`
    mutation confirmOfflinePaymentRequest($id: ID!) {
  confirmOfflinePaymentRequest(id: $id) {
    ...PaymentRequestFields
  }
}
    ${PaymentRequestFieldsFragmentDoc}`;
export type ConfirmOfflinePaymentRequestMutationFn = Apollo.MutationFunction<ConfirmOfflinePaymentRequestMutation, ConfirmOfflinePaymentRequestMutationVariables>;

/**
 * __useConfirmOfflinePaymentRequestMutation__
 *
 * To run a mutation, you first call `useConfirmOfflinePaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOfflinePaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOfflinePaymentRequestMutation, { data, loading, error }] = useConfirmOfflinePaymentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmOfflinePaymentRequestMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOfflinePaymentRequestMutation, ConfirmOfflinePaymentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOfflinePaymentRequestMutation, ConfirmOfflinePaymentRequestMutationVariables>(ConfirmOfflinePaymentRequestDocument, options);
      }
export type ConfirmOfflinePaymentRequestMutationHookResult = ReturnType<typeof useConfirmOfflinePaymentRequestMutation>;
export type ConfirmOfflinePaymentRequestMutationResult = Apollo.MutationResult<ConfirmOfflinePaymentRequestMutation>;
export type ConfirmOfflinePaymentRequestMutationOptions = Apollo.BaseMutationOptions<ConfirmOfflinePaymentRequestMutation, ConfirmOfflinePaymentRequestMutationVariables>;
export const CancelPaymentRequestDocument = gql`
    mutation cancelPaymentRequest($id: ID!) {
  cancelPaymentRequest(id: $id) {
    ...PaymentRequestFields
  }
}
    ${PaymentRequestFieldsFragmentDoc}`;
export type CancelPaymentRequestMutationFn = Apollo.MutationFunction<CancelPaymentRequestMutation, CancelPaymentRequestMutationVariables>;

/**
 * __useCancelPaymentRequestMutation__
 *
 * To run a mutation, you first call `useCancelPaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentRequestMutation, { data, loading, error }] = useCancelPaymentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPaymentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelPaymentRequestMutation, CancelPaymentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPaymentRequestMutation, CancelPaymentRequestMutationVariables>(CancelPaymentRequestDocument, options);
      }
export type CancelPaymentRequestMutationHookResult = ReturnType<typeof useCancelPaymentRequestMutation>;
export type CancelPaymentRequestMutationResult = Apollo.MutationResult<CancelPaymentRequestMutation>;
export type CancelPaymentRequestMutationOptions = Apollo.BaseMutationOptions<CancelPaymentRequestMutation, CancelPaymentRequestMutationVariables>;